import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboard20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconClipboard20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 1.25A1.75 1.75 0 0 0 5.75 3H5.5A2.5 2.5 0 0 0 3 5.5v10A2.5 2.5 0 0 0 5.5 18h9a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 14.5 3h-.25a1.75 1.75 0 0 0-1.75-1.75zm-2 3.25h.322A1.75 1.75 0 0 0 7.5 5.75h5a1.75 1.75 0 0 0 1.678-1.25h.322a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1M7.25 3a.25.25 0 0 1 .25-.25h5a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25h-5A.25.25 0 0 1 7.25 4zM10 7.5a.75.75 0 0 1 .75.75v2h2a.75.75 0 0 1 0 1.5h-2v2a.75.75 0 0 1-1.5 0v-2h-2a.75.75 0 0 1 0-1.5h2v-2A.75.75 0 0 1 10 7.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboard20);
